import React, { useEffect, useRef, useState } from "react";
import {
  ButtonCancel,
  ButtonCreate,
  ContentButtons,
  ContentFields,
  ContentFile,
  FieldFile,
  GeneralStyle,
  TextField,
  DateField,
  TextAreaField,
  RowOne,
  RowTwo,
  InfoLabel,
} from "./CreateGameComponent.styled";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { NotificationManager } from "react-notifications";
import PersonIcon from "@material-ui/icons/Person";
import FileUpload from "../FileUpload";
import InviteUsersGroupsContainer from "../../containers/InviteUsersGroupsContainer/InviteUsersGroupsContainer";
import { Form } from "react-bootstrap";
import moment from "moment";
import { theme as themeConfig } from "../../themes/themes";

const CreateGameComponent = ({
  files,
  setFiles,
  loadingCoverImage,
  SpaceEdit,
  createNew,
  updateOld,
  action,
  goToBackPage,
  usersAssigned,
}) => {
  const rName = useRef();
  const rTopic = useRef();
  const rDescription = useRef();
  const rUrl = useRef();
  const rInitialDate = useRef();
  const rFinishDate = useRef();
  const [usersSelection, setUsersSelection] = useState([]);
  const [groupsSelection, setGroupsSelection] = useState([]);
  const [, setDataBulkUpload] = useState([]);
  const [RenderAgain, setRenderAgain] = useState(false);
  const [editData, setEditData] = useState([]);
  const [usersSelected, setUsersSelected] = useState([]);
  const [groupsSelected, setGroupsSelected] = useState([]);

  const [folderName] = useState("Games");

  useEffect(() => {
    if (SpaceEdit) {
      rName.current.value = SpaceEdit.name;
      rTopic.current.value = SpaceEdit.topic;
      rUrl.current.value = SpaceEdit.url;
      const localStartDateTime = moment.utc(SpaceEdit.startDate).local().format("YYYY-MM-DDTHH:mm");
      rInitialDate.current.value = localStartDateTime;

      const localEndDateTime = moment.utc(SpaceEdit.endDate).local().format("YYYY-MM-DDTHH:mm");
      rFinishDate.current.value = localEndDateTime;


      let groups = SpaceEdit.wellnessGameGroups.map((item) => {
        let groupUsers = item.wellnessGameUsers.map((e) => e.userId);
        return {
          value: item.wellnessGameGroupId,
          label: item.name,
          name: item.name,
          userIds: groupUsers,
          groupName: item.name,
        };
      });
      setGroupsSelection(groups);
      setGroupsSelected(groups);
      rDescription.current.value = SpaceEdit.description;
      setRenderAgain(!RenderAgain);
    }
  }, [SpaceEdit]);

  useEffect(() => {
    if (usersAssigned.length > 0) {
      let usersSelected = [];
      usersSelected = usersAssigned.map((item) => {
        return {
          value: item.userId,
          label: item.firstName + " " + item?.lastName,
          name: item.firstName + " " + item?.lastName,
        };
      });
      setUsersSelection(usersSelected);
      setUsersSelected(usersSelected);
    }
  }, [usersAssigned]);

  useEffect(() => {
    setEditData({
      guests: usersSelection,
      groups: groupsSelection,
    });

    return () => {
      setEditData();
    };
  }, [usersSelection, groupsSelection]);

  const validateData = () => {
    let data = {};
    let missingData = false;
    let errorData = false;
    if (files.file) {
      data["file"] = files.file;
    }
    let usersCount = groupsSelected.length + usersSelected.length;
    if (
      !rName.current.value ||
      !rTopic.current.value ||
      !rInitialDate.current.value ||
      !rFinishDate.current.value ||
      !rUrl.current.value ||
      !rDescription.current.value ||
      usersCount === 0
    ) {
      missingData = true;
    } else {
      data["name"] = rName.current.value;
      data["topic"] = rTopic.current.value;
      data["startDate"] = rInitialDate.current.value;
      data["finishDate"] = rFinishDate.current.value;
      data["description"] = rDescription.current.value;
      data["url"] = rUrl.current.value;
    }
    if (!missingData && !errorData) {
      if (action === "add")
        createNew(data, groupsSelected, usersSelected, folderName);
      else if (action === "edit")
        updateOld(data, groupsSelected, usersSelected, folderName);
      return;
    }
    if (errorData)
      NotificationManager.warning("there are errors in the fields", "", 5000);
    else if (missingData)
      NotificationManager.warning("Missing fields", "", 5000);
  };

  return (
    <GeneralStyle>
      <div
        style={{
          color: "rgb(123, 123, 123)",
          fontWeight: "700",
          fontSize: "18px",
          display: "flex",
          padding: "0 30px",
          paddingTop: "30px",
        }}
      >
        <PersonIcon style={{ color: themeConfig.neutral.gray[2600] }} />
        {action === "add" ? "Create" : "Edit"} Game
      </div>
      <hr />
      <ContentFields>
        <RowOne>
          <TextField>
            <Form.Label>
              Game Name
              <span style={{ color: "red" }}> *</span>
            </Form.Label>{" "}
            <Form.Control
              type="text"
              ref={rName}
              placeholder="Type game name here"
              onChange={() => { }}
            />
          </TextField>
          <TextField>
            <Form.Label>
              Topic
              <span style={{ color: "red" }}> *</span>
            </Form.Label>{" "}
            <Form.Control
              type="text"
              ref={rTopic}
              placeholder="Type game topic here"
              onChange={() => { }}
            />
          </TextField>
          <DateField>
            <Form.Label>
              Game will be available from
              <span style={{ color: "red" }}> *</span>
            </Form.Label>{" "}
            <div className="date-fld" >
              <Form.Control
                type="datetime-local"
                ref={rInitialDate}
                placeholder="Start date"
                onChange={() => { }}

              />
              <Form.Control
                className="ml-4"
                type="datetime-local"
                ref={rFinishDate}
                placeholder="End date"
                onChange={() => { }}
              />
            </div>
          </DateField>
        </RowOne>
        <RowTwo>
          <div>
            <TextAreaField>
              <Form.Label>Description
                <span style={{ color: "red" }}> *</span>
              </Form.Label>{" "}
              <Form.Control
                as="textarea"
                rows={5}
                ref={rDescription}
                placeholder="Type game description here"
                onChange={() => { }}
              />
            </TextAreaField>
            <TextField style={{ marginTop: "10px" }}>
              <Form.Label>
                Enter the URL of the game
                <span style={{ color: "red" }}> *</span>
              </Form.Label>{" "}
              <Form.Control
                type="text"
                ref={rUrl}
                placeholder="Type game topic here"
                onChange={() => { }}
              />
            </TextField>
          </div>
          <FieldFile>
            <label>
              Cover image<span style={{ color: themeConfig.text.disabled }}>(Optional)</span>
            </label>
            <ContentFile>
              <FileUpload
                accept=".jpg,.png,.jpeg"
                setDataBulkUpload={setDataBulkUpload}
                setFiles={setFiles}
                files={files}
                loadingImage={loadingCoverImage}
                greyUI={true}
              />
            </ContentFile>
          </FieldFile>
        </RowTwo>
        <div className="users-container">
          <InviteUsersGroupsContainer
            editData={editData}
            action={action}
            setUsersSelected={setUsersSelected}
            setGroupsSelected={setGroupsSelected}
            columnDisplay={true}
            fieldLabel="Users assignation"
            groupAssignLabel="Group assignation"
            mandatory={true}
          />
        </div>
        <InfoLabel>
          <label>
            The fields marked with <span style={{ color: "red" }}> *</span> are
            required
          </label>
        </InfoLabel>
      </ContentFields>
      <hr />
      <ContentButtons>
        <ButtonCancel onClick={() => goToBackPage()}>Cancel</ButtonCancel>
        <ButtonCreate
          onClick={() => {
            validateData();
          }}
        >
          {action === "add" ? "Create" : "Update"} Game
        </ButtonCreate>
      </ContentButtons>
    </GeneralStyle>
  );
};

export default CreateGameComponent;
